const RELOADED_AT = 'tl:stale-chunk-reload';
const RELOAD_WINDOW_MS = 30_000;

/**
 * When Vite cannot fetch a lazy chunk (`vite:preloadError`), the tab was opened
 * before a deploy replaced the hashed files. A reload fetches the new index and
 * its chunks. Once per window: if the reload does not cure it (the server is
 * down), the route's error boundary takes over rather than looping.
 */
export function reloadOnStaleChunk(target: Window = window): void {
  target.addEventListener('vite:preloadError', (event) => {
    try {
      const last = Number(target.sessionStorage.getItem(RELOADED_AT) ?? 0);
      if (Date.now() - last < RELOAD_WINDOW_MS) return;
      target.sessionStorage.setItem(RELOADED_AT, String(Date.now()));
    } catch {
      return;
    }
    event.preventDefault();
    target.location.reload();
  });
}
